var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{ref:"tabela",staticClass:"floatThead",class:_vm.internalTableClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1af0b68","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/FloatThead/FloatThead.vue
// module id = 269
// module chunks = 134